import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import ClassificationMeter from '@components/charts/classificationMeter/index'
import { StatusContainer, ClassificationContainer } from '../styles'

const LifeHabitsStatus = ({
  lifeHabitsData, status, onChange, loading, beneficiaryWithCollectionCount
}) => {
  const { alcohol, smoking } = lifeHabitsData || 0

  return (
    <StatusContainer>
      <ClassificationContainer>
        <ClassificationMeter
          loading={loading}
          type="alcohol"
          status={status}
          onSelect={onChange}
          value={alcohol}
          maxValue={beneficiaryWithCollectionCount}
        />
        <ClassificationMeter
          loading={loading}
          type="smoking"
          status={status}
          onSelect={onChange}
          value={smoking}
          maxValue={beneficiaryWithCollectionCount}
        />
      </ClassificationContainer>

    </StatusContainer>
  )
}

LifeHabitsStatus.propTypes = {
  loading: PropTypes.bool,
  lifeHabitsData: PropTypes.shape({
    alcohol: PropTypes.number,
    smoking: PropTypes.number,
  }),
  status: PropTypes.shape({
    alcohol: PropTypes.bool,
    smoking: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  beneficiaryWithCollectionCount: PropTypes.number
}

LifeHabitsStatus.defaultProps = {
  lifeHabitsData: null,
  loading: false,
  beneficiaryWithCollectionCount: 0
}

const mapStateToProps = ({ overview, beneficiary }) => ({
  lifeHabitsData: overview.lifeHabitsData,
  beneficiaryWithCollectionCount: beneficiary.beneficiaryWithCollectionCount

})

export default connect(mapStateToProps, null)(LifeHabitsStatus)
